import { computed, inject, Injectable, signal } from '@angular/core';
import { DroplistItem, PageTabsLayoutPageService } from '@eforall/dashboard';
import { EngagementExternalRoleId, EngagementGridContainerPage, EngagementType, StaffRoleId } from '@interfaces';
import { VolunteeringAreaService } from '../volunteering-area.service';


/**
 * The list of tabs on this page
 */
export enum VolunteeringEngagementsPageTabId {
	Engagements = 1,
	Tab1 = 2,
	Tab2 = 3,
}

/**
 * The list of main tab droplist views on this page
 */
export enum VolunteeringEngagementsPageViewId {
	ContactRequests = 1,
	OpenEngagements = 2,
	CompletedEngagements = 3,
	ScheduledFollowUps = 4
}


@Injectable({ providedIn: 'root' })
export class VolunteeringEngagementsService extends PageTabsLayoutPageService<VolunteeringEngagementsPageTabId, VolunteeringEngagementsPageViewId> {

	public readonly areaService = inject(VolunteeringAreaService);
	public engagements = computed(() => this.areaService.volunteeringData()?.engagements || []);
	public followUps = computed(() => this.areaService.volunteeringData()?.followUps || []);
	public contactRequests = computed(() => this.areaService.volunteeringData()?.contactRequests || []);
	public readonly page = signal<EngagementGridContainerPage>(EngagementGridContainerPage.Volunteering);
	public engagementType = signal<EngagementType | undefined>(undefined);
	public readonly staffRoleId = signal<StaffRoleId | undefined>(undefined);
	public externalRoleId = signal<EngagementExternalRoleId | undefined>(EngagementExternalRoleId.Volunteer);
	private static readonly _viewDroplistItems1: DroplistItem<never, VolunteeringEngagementsPageViewId>[] = [
		{
			uniqueId: VolunteeringEngagementsPageViewId.ContactRequests,
			iconContext: {
				iconClass: 'fa-envelope-dot',
				iconStyle: 'fa-solid',
				text: 'Contact Requests',
				hideText: 'never',
			},
		},
		{
			uniqueId: VolunteeringEngagementsPageViewId.OpenEngagements,
			iconContext: {
				iconClass: 'fa-message-arrow-up-right',
				iconStyle: 'fa-solid',
				text: 'Open Engagements',
				hideText: 'never',
			},
		},
		{
			uniqueId: VolunteeringEngagementsPageViewId.CompletedEngagements,
			iconContext: {
				iconClass: 'fa-message-check',
				iconStyle: 'fa-solid',
				text: 'Completed Engagements',
				hideText: 'never',
			},
		},
		{
			uniqueId: VolunteeringEngagementsPageViewId.ScheduledFollowUps,
			iconContext: {
				iconClass: 'fa-reply-clock',
				iconStyle: 'fa-solid',
				text: 'Follow Ups',
				hideText: 'never',
			},
		},
	];

	constructor() {
		super(VolunteeringEngagementsService._viewDroplistItems1, VolunteeringEngagementsService.name, VolunteeringEngagementsPageTabId.Engagements, VolunteeringEngagementsPageViewId.ContactRequests);
	}

	public get viewId() {
		return VolunteeringEngagementsPageViewId;
	}


}